/**
 * API Gateway
 * API Gateway Единая точка входа для android, ios и web.  Модели ответов сервиса соответствуют спецификации, кроме случаев, когда возможны технические ответы (например, от ratelimiter или qrator). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';
import { API_OPTIONS_CONTEXT, ApiOptions }                   from '../api/api'

// @ts-ignore
import { AuthSessionGuestTokenResponse } from '../model/authSessionGuestTokenResponse';
// @ts-ignore
import { AuthSessionStart400Response } from '../model/authSessionStart400Response';
// @ts-ignore
import { AuthSessionStartRequest } from '../model/authSessionStartRequest';
// @ts-ignore
import { BadRequestResponse } from '../model/badRequestResponse';
// @ts-ignore
import { BaseResponse } from '../model/baseResponse';
// @ts-ignore
import { CallAuthStart200Response } from '../model/callAuthStart200Response';
// @ts-ignore
import { CallAuthStart400Response } from '../model/callAuthStart400Response';
// @ts-ignore
import { CallAuthStartRequest } from '../model/callAuthStartRequest';
// @ts-ignore
import { GetPassportGuestTokenResponse } from '../model/getPassportGuestTokenResponse';
// @ts-ignore
import { GetPassportToken409Response } from '../model/getPassportToken409Response';
// @ts-ignore
import { GetPassportTokenResponse } from '../model/getPassportTokenResponse';
// @ts-ignore
import { InternalServerErrorResponse } from '../model/internalServerErrorResponse';
// @ts-ignore
import { LentaSiteJRPCError } from '../model/lentaSiteJRPCError';
// @ts-ignore
import { MethodDeprecatedError } from '../model/methodDeprecatedError';
// @ts-ignore
import { PassportV2BaseError } from '../model/passportV2BaseError';
// @ts-ignore
import { PermissionDeniedResponse } from '../model/permissionDeniedResponse';
// @ts-ignore
import { RefreshPassportTokenRequest } from '../model/refreshPassportTokenRequest';
// @ts-ignore
import { SendAuthCode409Response } from '../model/sendAuthCode409Response';
// @ts-ignore
import { SendAuthCodeRequest } from '../model/sendAuthCodeRequest';
// @ts-ignore
import { SendAuthCodeResponse } from '../model/sendAuthCodeResponse';
// @ts-ignore
import { SessionLogoutRequest } from '../model/sessionLogoutRequest';
// @ts-ignore
import { SocialAuthStart200Response } from '../model/socialAuthStart200Response';
// @ts-ignore
import { SocialAuthStart400Response } from '../model/socialAuthStart400Response';
// @ts-ignore
import { SocialAuthStartRequest } from '../model/socialAuthStartRequest';
// @ts-ignore
import { SocialAuthValidate200Response } from '../model/socialAuthValidate200Response';
// @ts-ignore
import { SocialAuthValidateRequest } from '../model/socialAuthValidateRequest';
// @ts-ignore
import { SuccessResult } from '../model/successResult';
// @ts-ignore
import { SyncAuthSessionRequest } from '../model/syncAuthSessionRequest';
// @ts-ignore
import { SyncAuthSessionResponse } from '../model/syncAuthSessionResponse';
// @ts-ignore
import { UnauthorizedResponse } from '../model/unauthorizedResponse';
// @ts-ignore
import { VerifyAuthCodeRequest } from '../model/verifyAuthCodeRequest';
// @ts-ignore
import { VerifyAuthCodeResponse } from '../model/verifyAuthCodeResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface AuthSessionGuestTokenRequestParams {
    /** Уникальный идентификатор устройства */
    deviceID: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface AuthSessionStartRequestParams {
    /** Уникальный идентификатор устройства */
    deviceId: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand: string;
    /** Источник (платформа) запроса */
    xPlatform: string;
    /** Токен доступа Passport в формате JWT. */
    passportAccessToken: string;
    /** Passport refresh token, закодированный в base64. */
    refreshToken?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    authSessionStartRequest?: AuthSessionStartRequest;
}

export interface CallAuthStartRequestParams {
    /** Уникальный идентификатор устройства */
    deviceId: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk' | 'tgbot02';
    /** Параметры запроса */
    callAuthStartRequest: CallAuthStartRequest;
    /** Гостевой токен доступа в формате JWT. */
    passportAccessToken?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetPassportGuestTokenRequestParams {
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Уникальный идентификатор устройства */
    xDeviceID: string;
    /** ОС устройства */
    xDeviceOS: 'iOS' | 'Android' | 'Web';
    /** Версия приложения */
    appVersion?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** IDFA идентификатор */
    advertisingId?: string;
    /** Тип веб-платформы устройства */
    xDeviceWebPlatform?: 'desktop_web' | 'mobile_web' | 'pwa' | 'max' | 'telegram' | 'okey_app' | 'okey_web' | 'other' | 'none';
    /** Технический заголовок для SSR-контекста. SSR - Server Side Rendering.  - &#x60;true&#x60; - JWT токены (accessToken, refreshToken) возвращаются в теле ответа; HttpOnly куки не устанавливаются. - &#x60;false&#x60; или отсутствует - JWT токены в теле ответа не передаются; устанавливаются HttpOnly куки PassportAccessToken и PassportRefreshToken.  */
    ssr?: boolean;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetPassportTokenRequestParams {
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface RefreshPassportTokenRequestParams {
    /** Параметры запроса */
    refreshPassportTokenRequest: RefreshPassportTokenRequest;
    /** Токен для обновления токена доступа Паспорта. */
    passportRefreshToken?: string;
    /** Источник (платформа) запроса */
    xPlatform?: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Технический заголовок для SSR-контекста. SSR - Server Side Rendering.  - &#x60;true&#x60; - JWT токены (accessToken, refreshToken) возвращаются в теле ответа; HttpOnly куки не устанавливаются. - &#x60;false&#x60; или отсутствует - JWT токены в теле ответа не передаются; устанавливаются HttpOnly куки PassportAccessToken и PassportRefreshToken.  */
    ssr?: boolean;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    /** Сессионный токен Монолита. Всегда используется вместе с DeviceId. Используется для актуализации гостевой куки PassportAccessToken у авторизованных по Монолиту пользователей (AGW-473).  */
    sessionToken?: string;
    /** Уникальный идентификатор устройства. Всегда используется вместе с SessionToken. */
    deviceId?: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand?: string;
}

export interface SendAuthCodeRequestParams {
    /** Уникальный идентификатор устройства */
    deviceID: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Параметры запроса */
    sendAuthCodeRequest: SendAuthCodeRequest;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** По данному заголовку определяются переданные feature флаги. */
    xFeatureFlags?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
}

export interface SessionLogoutRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    /** Параметры запроса */
    sessionLogoutRequest?: SessionLogoutRequest;
}

export interface SocialAuthStartRequestParams {
    /** Уникальный идентификатор устройства */
    deviceId: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk' | 'tgbot02';
    /** Параметры запроса */
    socialAuthStartRequest: SocialAuthStartRequest;
    /** Гостевой токен доступа в формате JWT. */
    passportAccessToken?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface SocialAuthValidateRequestParams {
    /** Уникальный идентификатор устройства */
    deviceId: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk' | 'tgbot02';
    /** Параметры запроса */
    socialAuthValidateRequest: SocialAuthValidateRequest;
    /** Гостевой токен доступа в формате JWT. */
    passportAccessToken?: string;
    /** Гостевая сессия монолита для переноса адреса, корзины и магазина после входа */
    sessionToken?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface SyncAuthSessionRequestParams {
    /** Уникальный идентификатор устройства */
    deviceID: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Параметры запроса */
    syncAuthSessionRequest: SyncAuthSessionRequest;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface VerifyAuthCodeRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    deviceID: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Параметры запроса */
    verifyAuthCodeRequest: VerifyAuthCodeRequest;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Технический заголовок для SSR-контекста. SSR - Server Side Rendering.  - &#x60;true&#x60; - JWT токены (accessToken, refreshToken) возвращаются в теле ответа; HttpOnly куки не устанавливаются. - &#x60;false&#x60; или отсутствует - JWT токены в теле ответа не передаются; устанавливаются HttpOnly куки PassportAccessToken и PassportRefreshToken.  */
    ssr?: boolean;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}


@Injectable({
  providedIn: 'root'
})
export class AuthService {

    protected basePath = 'https://api.lenta.com/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Получение гостевой сэссии
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public authSessionGuestToken(requestParameters: AuthSessionGuestTokenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<AuthSessionGuestTokenResponse>;
    public authSessionGuestToken(requestParameters: AuthSessionGuestTokenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<AuthSessionGuestTokenResponse>>;
    public authSessionGuestToken(requestParameters: AuthSessionGuestTokenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<AuthSessionGuestTokenResponse>>;
    public authSessionGuestToken(requestParameters: AuthSessionGuestTokenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const deviceID = requestParameters.deviceID;
        if (deviceID === null || deviceID === undefined) {
            throw new Error('Required parameter deviceID was null or undefined when calling authSessionGuestToken.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling authSessionGuestToken.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling authSessionGuestToken.');
        }
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (deviceID !== undefined && deviceID !== null) {
            localVarHeaders = localVarHeaders.set('DeviceID', String(deviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'CL',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/auth/session/guest/token`;
        return this.httpClient.request<AuthSessionGuestTokenResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получение сессионного токена монолита по passport-токену
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public authSessionStart(requestParameters: AuthSessionStartRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<AuthSessionGuestTokenResponse>;
    public authSessionStart(requestParameters: AuthSessionStartRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<AuthSessionGuestTokenResponse>>;
    public authSessionStart(requestParameters: AuthSessionStartRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<AuthSessionGuestTokenResponse>>;
    public authSessionStart(requestParameters: AuthSessionStartRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const deviceId = requestParameters.deviceId;
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling authSessionStart.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling authSessionStart.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling authSessionStart.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        if (passportAccessToken === null || passportAccessToken === undefined) {
            throw new Error('Required parameter passportAccessToken was null or undefined when calling authSessionStart.');
        }
        const refreshToken = requestParameters.refreshToken;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const authSessionStartRequest = requestParameters.authSessionStartRequest;

        let localVarHeaders = this.defaultHeaders;
        if (deviceId !== undefined && deviceId !== null) {
            localVarHeaders = localVarHeaders.set('DeviceId', String(deviceId));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (refreshToken !== undefined && refreshToken !== null) {
            localVarHeaders = localVarHeaders.set('RefreshToken', String(refreshToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'GR',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/auth/session/start`;
        return this.httpClient.request<AuthSessionGuestTokenResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: authSessionStartRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Старт аутентификации через Call Password ID
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public callAuthStart(requestParameters: CallAuthStartRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<CallAuthStart200Response>;
    public callAuthStart(requestParameters: CallAuthStartRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<CallAuthStart200Response>>;
    public callAuthStart(requestParameters: CallAuthStartRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<CallAuthStart200Response>>;
    public callAuthStart(requestParameters: CallAuthStartRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const deviceId = requestParameters.deviceId;
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling callAuthStart.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling callAuthStart.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling callAuthStart.');
        }
        const callAuthStartRequest = requestParameters.callAuthStartRequest;
        if (callAuthStartRequest === null || callAuthStartRequest === undefined) {
            throw new Error('Required parameter callAuthStartRequest was null or undefined when calling callAuthStart.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (deviceId !== undefined && deviceId !== null) {
            localVarHeaders = localVarHeaders.set('DeviceId', String(deviceId));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'GR',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/auth/call/start`;
        return this.httpClient.request<CallAuthStart200Response>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: callAuthStartRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получение гостевых токенов Паспорта
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPassportGuestToken(requestParameters: GetPassportGuestTokenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GetPassportGuestTokenResponse>;
    public getPassportGuestToken(requestParameters: GetPassportGuestTokenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GetPassportGuestTokenResponse>>;
    public getPassportGuestToken(requestParameters: GetPassportGuestTokenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GetPassportGuestTokenResponse>>;
    public getPassportGuestToken(requestParameters: GetPassportGuestTokenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling getPassportGuestToken.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getPassportGuestToken.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        if (xDeviceID === null || xDeviceID === undefined) {
            throw new Error('Required parameter xDeviceID was null or undefined when calling getPassportGuestToken.');
        }
        const xDeviceOS = requestParameters.xDeviceOS;
        if (xDeviceOS === null || xDeviceOS === undefined) {
            throw new Error('Required parameter xDeviceOS was null or undefined when calling getPassportGuestToken.');
        }
        const appVersion = requestParameters.appVersion;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const advertisingId = requestParameters.advertisingId;
        const xDeviceWebPlatform = requestParameters.xDeviceWebPlatform;
        const ssr = requestParameters.ssr;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (appVersion !== undefined && appVersion !== null) {
            localVarHeaders = localVarHeaders.set('App-Version', String(appVersion));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (advertisingId !== undefined && advertisingId !== null) {
            localVarHeaders = localVarHeaders.set('AdvertisingId', String(advertisingId));
        }
        if (xDeviceWebPlatform !== undefined && xDeviceWebPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Web-Platform', String(xDeviceWebPlatform));
        }
        if (ssr !== undefined && ssr !== null) {
            localVarHeaders = localVarHeaders.set('ssr', String(ssr));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (PassportRefreshToken) required
        localVarCredential = this.configuration.lookupCredential('PassportRefreshToken');
        if (localVarCredential) {
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'CL',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/auth/passport/token/guest`;
        return this.httpClient.request<GetPassportGuestTokenResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получение токенов Паспорта по сессии пользователя
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPassportToken(requestParameters: GetPassportTokenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GetPassportTokenResponse>;
    public getPassportToken(requestParameters: GetPassportTokenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GetPassportTokenResponse>>;
    public getPassportToken(requestParameters: GetPassportTokenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GetPassportTokenResponse>>;
    public getPassportToken(requestParameters: GetPassportTokenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling getPassportToken.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getPassportToken.');
        }
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'CL',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/auth/passport/token`;
        return this.httpClient.request<GetPassportTokenResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Перевыпуск токенов Паспорта
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public refreshPassportToken(requestParameters: RefreshPassportTokenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GetPassportTokenResponse>;
    public refreshPassportToken(requestParameters: RefreshPassportTokenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GetPassportTokenResponse>>;
    public refreshPassportToken(requestParameters: RefreshPassportTokenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GetPassportTokenResponse>>;
    public refreshPassportToken(requestParameters: RefreshPassportTokenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const refreshPassportTokenRequest = requestParameters.refreshPassportTokenRequest;
        if (refreshPassportTokenRequest === null || refreshPassportTokenRequest === undefined) {
            throw new Error('Required parameter refreshPassportTokenRequest was null or undefined when calling refreshPassportToken.');
        }
        const passportRefreshToken = requestParameters.passportRefreshToken;
        const xPlatform = requestParameters.xPlatform;
        const ssr = requestParameters.ssr;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const sessionToken = requestParameters.sessionToken;
        const deviceId = requestParameters.deviceId;
        const xRetailBrand = requestParameters.xRetailBrand;

        let localVarHeaders = this.defaultHeaders;
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (ssr !== undefined && ssr !== null) {
            localVarHeaders = localVarHeaders.set('ssr', String(ssr));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (deviceId !== undefined && deviceId !== null) {
            localVarHeaders = localVarHeaders.set('DeviceId', String(deviceId));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }

        let localVarCredential: string | undefined;
        // authentication (PassportRefreshToken) required
        localVarCredential = this.configuration.lookupCredential('PassportRefreshToken');
        if (localVarCredential) {
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'CL',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/auth/passport/token/refresh`;
        return this.httpClient.request<GetPassportTokenResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: refreshPassportTokenRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Отправка кода подтверждения пользователю
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendAuthCode(requestParameters: SendAuthCodeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<SendAuthCodeResponse>;
    public sendAuthCode(requestParameters: SendAuthCodeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<SendAuthCodeResponse>>;
    public sendAuthCode(requestParameters: SendAuthCodeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<SendAuthCodeResponse>>;
    public sendAuthCode(requestParameters: SendAuthCodeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const deviceID = requestParameters.deviceID;
        if (deviceID === null || deviceID === undefined) {
            throw new Error('Required parameter deviceID was null or undefined when calling sendAuthCode.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling sendAuthCode.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling sendAuthCode.');
        }
        const sendAuthCodeRequest = requestParameters.sendAuthCodeRequest;
        if (sendAuthCodeRequest === null || sendAuthCodeRequest === undefined) {
            throw new Error('Required parameter sendAuthCodeRequest was null or undefined when calling sendAuthCode.');
        }
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const xFeatureFlags = requestParameters.xFeatureFlags;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const passportAccessToken = requestParameters.passportAccessToken;

        let localVarHeaders = this.defaultHeaders;
        if (deviceID !== undefined && deviceID !== null) {
            localVarHeaders = localVarHeaders.set('DeviceID', String(deviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (xFeatureFlags !== undefined && xFeatureFlags !== null) {
            localVarHeaders = localVarHeaders.set('X-Feature-Flags', String(xFeatureFlags));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'GR',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/auth/code/send`;
        return this.httpClient.request<SendAuthCodeResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: sendAuthCodeRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Завершение сессии.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sessionLogout(requestParameters: SessionLogoutRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<SuccessResult>;
    public sessionLogout(requestParameters: SessionLogoutRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<SuccessResult>>;
    public sessionLogout(requestParameters: SessionLogoutRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<SuccessResult>>;
    public sessionLogout(requestParameters: SessionLogoutRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling sessionLogout.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling sessionLogout.');
        }
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const sessionLogoutRequest = requestParameters.sessionLogoutRequest;

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'CL',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/auth/session/logout`;
        return this.httpClient.request<SuccessResult>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: sessionLogoutRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Старт аутентификации через внешнего провайдера
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public socialAuthStart(requestParameters: SocialAuthStartRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<SocialAuthStart200Response>;
    public socialAuthStart(requestParameters: SocialAuthStartRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<SocialAuthStart200Response>>;
    public socialAuthStart(requestParameters: SocialAuthStartRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<SocialAuthStart200Response>>;
    public socialAuthStart(requestParameters: SocialAuthStartRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const deviceId = requestParameters.deviceId;
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling socialAuthStart.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling socialAuthStart.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling socialAuthStart.');
        }
        const socialAuthStartRequest = requestParameters.socialAuthStartRequest;
        if (socialAuthStartRequest === null || socialAuthStartRequest === undefined) {
            throw new Error('Required parameter socialAuthStartRequest was null or undefined when calling socialAuthStart.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (deviceId !== undefined && deviceId !== null) {
            localVarHeaders = localVarHeaders.set('DeviceId', String(deviceId));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'GR',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/auth/social/start`;
        return this.httpClient.request<SocialAuthStart200Response>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: socialAuthStartRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Валидация аутентификации через внешнего провайдера
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public socialAuthValidate(requestParameters: SocialAuthValidateRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<SocialAuthValidate200Response>;
    public socialAuthValidate(requestParameters: SocialAuthValidateRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<SocialAuthValidate200Response>>;
    public socialAuthValidate(requestParameters: SocialAuthValidateRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<SocialAuthValidate200Response>>;
    public socialAuthValidate(requestParameters: SocialAuthValidateRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const deviceId = requestParameters.deviceId;
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling socialAuthValidate.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling socialAuthValidate.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling socialAuthValidate.');
        }
        const socialAuthValidateRequest = requestParameters.socialAuthValidateRequest;
        if (socialAuthValidateRequest === null || socialAuthValidateRequest === undefined) {
            throw new Error('Required parameter socialAuthValidateRequest was null or undefined when calling socialAuthValidate.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const sessionToken = requestParameters.sessionToken;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (deviceId !== undefined && deviceId !== null) {
            localVarHeaders = localVarHeaders.set('DeviceId', String(deviceId));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'GR',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/auth/social/validate`;
        return this.httpClient.request<SocialAuthValidate200Response>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: socialAuthValidateRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Синхронизация сессий авторизации (EPI+монолит)
     * Метод больше не актуален. Всегда вернет 500.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public syncAuthSession(requestParameters: SyncAuthSessionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<SyncAuthSessionResponse>;
    public syncAuthSession(requestParameters: SyncAuthSessionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<SyncAuthSessionResponse>>;
    public syncAuthSession(requestParameters: SyncAuthSessionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<SyncAuthSessionResponse>>;
    public syncAuthSession(requestParameters: SyncAuthSessionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const deviceID = requestParameters.deviceID;
        if (deviceID === null || deviceID === undefined) {
            throw new Error('Required parameter deviceID was null or undefined when calling syncAuthSession.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling syncAuthSession.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling syncAuthSession.');
        }
        const syncAuthSessionRequest = requestParameters.syncAuthSessionRequest;
        if (syncAuthSessionRequest === null || syncAuthSessionRequest === undefined) {
            throw new Error('Required parameter syncAuthSessionRequest was null or undefined when calling syncAuthSession.');
        }
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (deviceID !== undefined && deviceID !== null) {
            localVarHeaders = localVarHeaders.set('DeviceID', String(deviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'CL',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/auth/session/sync`;
        return this.httpClient.request<SyncAuthSessionResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: syncAuthSessionRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Проверка кода подтверждения, получение токена в случае успеха
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public verifyAuthCode(requestParameters: VerifyAuthCodeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<VerifyAuthCodeResponse>;
    public verifyAuthCode(requestParameters: VerifyAuthCodeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<VerifyAuthCodeResponse>>;
    public verifyAuthCode(requestParameters: VerifyAuthCodeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<VerifyAuthCodeResponse>>;
    public verifyAuthCode(requestParameters: VerifyAuthCodeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling verifyAuthCode.');
        }
        const deviceID = requestParameters.deviceID;
        if (deviceID === null || deviceID === undefined) {
            throw new Error('Required parameter deviceID was null or undefined when calling verifyAuthCode.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling verifyAuthCode.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling verifyAuthCode.');
        }
        const verifyAuthCodeRequest = requestParameters.verifyAuthCodeRequest;
        if (verifyAuthCodeRequest === null || verifyAuthCodeRequest === undefined) {
            throw new Error('Required parameter verifyAuthCodeRequest was null or undefined when calling verifyAuthCode.');
        }
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const ssr = requestParameters.ssr;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (deviceID !== undefined && deviceID !== null) {
            localVarHeaders = localVarHeaders.set('DeviceID', String(deviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (ssr !== undefined && ssr !== null) {
            localVarHeaders = localVarHeaders.set('ssr', String(ssr));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (PassportRefreshToken) required
        localVarCredential = this.configuration.lookupCredential('PassportRefreshToken');
        if (localVarCredential) {
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'GR',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/auth/code/verify`;
        return this.httpClient.request<VerifyAuthCodeResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: verifyAuthCodeRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
